<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="12" md="8" align="center">
      <v-card class="mt-3">
        <v-card-text v-if="announcement">
          <v-alert type="warning" dense outlined class="text-left">
            <p>{{ announcement | capitalize }}</p>
          </v-alert>
        </v-card-text>
        <template v-if="isTracked">
          <v-card-text>
            <img :src="tracked.qrcode" />
            <h4>
              Due: {{ tracked.due | currency }} | Tracking id :
              {{ tracked.key }} | Paid :
              {{ tracked.prePaid | currency }}
            </h4>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left" width="20%">
                      Status
                    </th>
                    <td>
                      <template v-if="tracked.status">
                        <span class="success--text">
                          Complete @ {{ tracked.updated_at }}</span
                        >
                      </template>
                      <template v-else>
                        <span class="info--text"> Pending</span>
                      </template>
                    </td>
                  </tr>
                  <tr class="text-left">
                    <th>
                      Name
                    </th>
                    <td>{{ tracked.name | capitalize }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Device Name
                    </th>
                    <td>{{ tracked.deviceName | capitalize }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Device SN #
                    </th>
                    <td>{{ tracked.sNumber | capitalize }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      IMEI #
                    </th>
                    <td>{{ tracked.imei | capitalize }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Charges
                    </th>
                    <td>{{ tracked.charges | currency }}</td>
                  </tr>

                  <tr>
                    <th>Issue:</th>
                    <td colspan="2">
                      {{ tracked.issue | capitalize }}
                    </td>
                  </tr>
                  <tr v-if="tracked.message">
                    <th>Message:</th>
                    <td colspan="2">
                      {{ tracked.message | capitalize }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn class="info mt-2" small @click="reset">
              Back
            </v-btn>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="key"
                  hide-details="auto"
                  label="Enter Repair Tracking ID"
                  outlined
                  autofocus
                  dense
                  :loading="loading"
                  :error-messages="message"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  :loading="loading"
                  :disabled="!key"
                  @click="track"
                  class="info"
                >
                  <v-icon>
                    mdi-search-web
                  </v-icon>
                  Track
                </v-btn>
                <v-btn class="warning" href="/welcome">
                  <v-icon>
                    mdi-home
                  </v-icon>
                  Back
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    trackingFor: { type: Number, default: 0 },
  },
  data() {
    return {
      key: "",
      isTracked: false,
      tracked: {},
      message: "",
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      main: "configs/overall",
      loading: "overlay/processing",
    }),
    announcement() {
      return this.main.announcement;
    },
  },
  mounted() {
    if (this.trackingFor > 0) {
      this.$data.key = this.trackingFor;
      this.track();
    }
  },

  methods: {
    reset() {
      this.$data.isTracked = false;
    },
    track() {
      window.axios.post("/track-repair", { key: this.key }).then((response) => {
        if (response.data.message) {
          this.message = response.data.message;
        } else {
          this.$data.tracked = response.data.tracked;
          this.$data.isTracked = true;
        }
      });
    },
  },
};
</script>
